import * as config from './config'

const IS_STAGING_APP = (/(^|\.)staging.swordhealth\.(tech|com)/).test(window.location.hostname)
const USER_ROLES = {
  all: '*',
  editor: 'editor',
  guest: 'guest',
}

const CONFIG = {
  baseUrl: config.get('BASE_URL'),
  broadcastChannelName: config.get('BROADCAST_CHANNEL_NAME') || 'clinical-portal-broadcast',
  onboardingApiUrl: config.get('ONBOARDING_API_URL'),
  cardsApiUrl: config.get('CARDS_API_URL'),
  assetsApiUrl: config.get('ASSETS_API_URL'),
  chatApiUrl: config.get('CHAT_API_URL'),
  stateMachineApiUrl: config.get('STATE_MACHINE_API_URL'),
  therapy: '',
  enableAnalytics: config.get('ENABLE_ANALYTICS'),
  analyticsKey: config.get('ANALYTICS_KEY'),
  segmentKey: config.get('SEGMENT_KEY'),
  segmentCustomDebug: config.get('SEGMENT_CUSTOM_DEBUG'), // Custom analytics debug
  segmentDebug: config.get('SEGMENT_DEBUG'), // Segment original debug
  enableDebug: config.get('ENABLE_DEBUG') === 'true',
  defaultPhonePrefix: config.get('PHONE_PREFIX') || '+1',
  useHttpMocks: (config.get('DEMO_MODE') === 'true') || false,
  environment: config.get('ENVIRONMENT'),
  HGMockCCDA: config.get('HG_MOCK_CCDA') === 'true' || false,
  govEnv: config.get('GOV_ENV') === 'true' || false,
}

const SESSION_TIMEOUT_CONFIG = {
  autoLogoutTimeout: config.get('AUTO_LOGOUT_TIMEOUT') || 900, // Revert for config enabling.
  sessionTimerStartCookieName: 'session_timer_start',
}

const USER_STORAGE = {
  key: 'userSHCP',
}

const SYSTEM_STORAGE = {
  key: 'systemSHCP',
}

const AUTH_COOKIE = {
  token_expires: Number(config.get('TOKEN_COOKIE_LIFE_TIME') || 2),
  token_domain: config.get('TOKEN_COOKIE_DOMAIN'),
  token_name: 'atoken_sword',
  token_expires_date_name: 'atoken_expires_sword',
  token_validity_minutes: 15,
  refresh_token_name: 'rtoken_sword',
  base_url_expires: 10,
  secure: process.env.NODE_ENV !== 'development',
}

const EXTERNAL_LINKS = {
  uiPortal: {
    url: config.get('UI_PORTAL_URL'),
    target: `sword-health-ui-portal-window-${new Date().getTime()}`,
    chatTarget: `sword-health-ui-portal-chat-window-${new Date().getTime()}`,
  },
  therapistChat: {
    url: config.get('THERAPIST_CHAT_URL'),
    target: 'sword-health-therapist-chat-window',
  },
  supportAndHelp: {
    url: config.get('SUPPORT_FORM_URL'),
    target: 'sword-health-support-and-help-window',
  },
}

const APP_THEME = {
  key: 'APP_THEME',
  availableThemes: [
    'sword',
  ],
  default: 'sword',
}

// eslint-disable-next-line
let VERSION_FILE = {};

try {
  // eslint-disable-next-line
  VERSION_FILE = require('@/version.json');
} catch (ex) {
  console.log('NO VERSION FILE AVAILABLE')
}

const FEATURE_TOGGLE = {
  uiPortalRedirect: false,
  USE_UI_PORTAL_CHAT: config.get('USE_UI_PORTAL_CHAT') === 'true',
  ENABLE_AIFEED_NEWSFEED: config.get('ENABLE_AIFEED_NEWSFEED') === 'true',
  SWORD_DESK_ENABLED: config.get('SWORD_DESK_ENABLED') === 'true',
}

const NEWRELIC_CONFIG = {
  NEW_RELIC_ENABLED: config.get('NEW_RELIC_ENABLED') ?? true,
  NEW_RELIC_ACCOUNT_ID: config.get('NEW_RELIC_ACCOUNT_ID') || '',
  NEW_RELIC_AGENT_ID: config.get('NEW_RELIC_AGENT_ID') || '',
  NEW_RELIC_LICENSE_KEY: config.get('NEW_RELIC_LICENSE_KEY') || '',
  NEW_RELIC_APPLICATION_ID: config.get('NEW_RELIC_APPLICATION_ID') || '',
  NEW_RELIC_TRUST_KEY: config.get('NEW_RELIC_TRUST_KEY') || '',
}

const SMS_CHAR_LIMIT = 800

const SMS_CHARACTER_LIMIT_THRESHOLD = 0.8

const SMS_CHAR_LIMIT_TO_WARN = SMS_CHAR_LIMIT * SMS_CHARACTER_LIMIT_THRESHOLD

const TOASTER_TIME = 2500

const TOASTER_KEY = 'notification'

const NOTE_TITLE_MAX_LENGTH = 20

const ADDRESS_LINE_MAX_LENGTH = 35

export {
  IS_STAGING_APP,
  APP_THEME,
  USER_ROLES,
  USER_STORAGE,
  SYSTEM_STORAGE,
  CONFIG,
  SESSION_TIMEOUT_CONFIG,
  VERSION_FILE,
  AUTH_COOKIE,
  EXTERNAL_LINKS,
  FEATURE_TOGGLE,
  NEWRELIC_CONFIG,
  SMS_CHAR_LIMIT,
  SMS_CHAR_LIMIT_TO_WARN,
  TOASTER_TIME,
  TOASTER_KEY,
  NOTE_TITLE_MAX_LENGTH,
  ADDRESS_LINE_MAX_LENGTH,
}
